export default [
  // Guest Routes
  {
    path: '/login',
    name: 'login.index',
    component: () => import('@/views/Login/Index'),
    meta: {
      perimeter: 'GuestPerimeter',
    },
  },

  {
    path: '/',
    redirect: '/home',
  },

  {
    path: '/*',
    name: 'not-found',
    component: () => import('@/views/Errors/404.vue'),
  },
];



// WEBPACK FOOTER //
// ./src/routes/guest.js